import Vue from 'vue'
import Store from './store'

import moment from 'moment'
import timezone from 'moment-timezone'
import useragent from 'ua-parser-js'

moment.locale('nl')

Vue.filter('useragent', function (value) {
  const agent = useragent(value)
  return `${agent.os.name}, ${agent.browser.name}`
})

Vue.filter('date', function (date, format = 'LLL') {
  return moment(date).format(format)
})

Vue.filter('timezone', function (date, zone = 'Europe/Amsterdam') {
  return timezone.tz(date, zone).format()
})

Vue.filter('crediteur', function (id) {
  const crediteur = Store.getters.crediteuren.find((object) => {
    return object.subNr === id || object.id === id
  })

  if (!crediteur) {
    return id
  }

  return crediteur.acctName
})

Vue.filter('crediteurNumber', function (id) {
  const crediteur = Store.getters.crediteuren.find((object) => {
    return object.subNr === id || object.id === id
  })

  if (!crediteur) {
    return id
  }

  return crediteur.subNr
})

Vue.filter('debiteur', function (id) {
  const debiteur = Store.getters.debiteuren.find((object) => {
    return object.subNr === id || object.id === id
  })

  if (!debiteur) {
    return id
  }

  return debiteur.acctName
})

Vue.filter('debiteurNumber', function (id) {
  const debiteur = Store.getters.debiteuren.find((object) => {
    return object.subNr === id || object.id === id
  })

  if (!debiteur) {
    return id
  }

  return debiteur.subNr
})

Vue.filter('receiptDocument', function (id) {
  const receipt = Store.getters.allReceipts.find((object) => {
    return object.id === id
  })

  return receipt.document
})

Vue.filter('vatCode', function (id) {
  const settings = Store.getters.settings

  if (!settings || !settings['accountview.vat.codes']) {
    return
  }

  const vat = settings['accountview.vat.codes'].find((object) => {
    return object.id === id
  })

  if (!vat) {
    return
  }

  return vat.name
})



// WEBPACK FOOTER //
// ./src/filters.js